import gql from "graphql-tag";

export const USER_PROGRAMS_QUERY = gql`
  query ClientUserPrograms($userId: ID!) {
    clientUserPrograms(userId: $userId) {
      subscriptionName
      paidUpUntil
      userProfile {
        id
        coachingNutritionPlan {
          id
          servingSize
          dietaryRestriction
          createdAt
          pdf
        }
        nutritionPlan {
          id
          name
          pdf
        }
      }

      userPrograms {
        id
        programStartDate
        disabled
        nutritionPlan {
          id
          name
          pdf
        }
        program {
          id
          name
          difficulty
          nextProgramBlock {
            id
            name
          }
        }
        assessments {
          id
          requiredDate
        }
        coach {
          id
          firstName
          lastName
          profile {
            id
            recurringAssessmentLink
            initialAssessmentLink
          }
        }
        nextProgram {
          id
          name
        }
        secondaryCoachUserPrograms {
          edges {
            node {
              id
              period {
                id
                startDate
                endDate
              }
              secondaryCoach {
                id
                firstName
                lastName
              }
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_USER_PROGRAM_MUTATION = gql`
  mutation updateUserProgram($userProgramId: ID!, $programId: ID, $nextProgramId: ID) {
    updateUserProgram(userProgramId: $userProgramId, programId: $programId, nextProgramId: $nextProgramId) {
      updated
      error
    }
  }
`;

export const COACHING_CLIENT_ACTIVE_SUBSCRIPTION_QUERY = gql`
  query activeSubscription($userId: ID!) {
    activeSubscription(userId: $userId) {
      id
      startDate
      stage
      product {
        id
        name
        type
      }
      user {
        id
        userProfile {
          id
          nutritionPlan {
            id
            name
            pdf
          }
          coachingNutritionPlan {
            id
            servingSize
            dietaryRestriction
            pdf
          }
        }
      }
      coach {
        id
        firstName
        lastName
      }
    }
  }
`;

export const PROGRAMS_QUERY = gql`
  query programs {
    programs {
      id
      name
    }
  }
`;
